export const compare = (id1,id2)=>id1 === id2